import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentMethodCreditCardValue_charge$key } from './__generated__/PaymentMethodCreditCardValue_charge.graphql.ts';

type PaymentMethodCreditCardValueProps = {
  charge: PaymentMethodCreditCardValue_charge$key;
};

const PaymentMethodCreditCardValue = (
  props: PaymentMethodCreditCardValueProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentMethodCreditCardValue_charge$key>(
    graphql`
      fragment PaymentMethodCreditCardValue_charge on Charge {
        value
        company {
          nameFriendly
        }
      }
    `,
    props.charge,
  );

  return (
    <Typography variant='h5' fontWeight='bold' textAlign='center'>
      {t('Pay {{value}} to {{companyName}} via Credit Card', {
        value: convertToMoney(charge?.value as number),
        companyName: charge?.company?.nameFriendly,
      })}
    </Typography>
  );
};

export default PaymentMethodCreditCardValue;
